import React from "react";
import './Sidebar.scss';
import {useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import StarBorderOutlinedIcon from '@material-ui/icons/StarBorderOutlined';
import {selectFollows} from "../slices/profile";
import gsap from 'gsap';
import {useTranslation} from "react-i18next";
import {ROUTES} from "../db/models/const";

export const StudentSidebar = () => {
    const rms = useSelector(selectFollows);
    const history = useHistory();
    const {t} = useTranslation();

    const onRmClick = (rm) => {
        // dispatch(storeSelectedRm({ rm }));
        closeSidebar();
        history.push(ROUTES.FOLLOW.replace(":rmId", rm.id));
    };

    // useEffect(() => {
    //     console.log("CHECK COOKIEEEEEEEEEEEEEEEEEEEEEE")
    //     const rmTutorialCookie = Cookies.get("rmTutorialDone");

    //     if(rmTutorialCookie)
    // }, []);

    const closeSidebar = () => {
        if (window.innerWidth > 768) return;
        const tl = gsap.timeline()
        tl
            .to('.sidebar', {duration: 0.1, xPercent: -100})
            .set('.sidebar', {display: 'none', xPercent: -100});
    }

    const onSelect = (url) => {
        closeSidebar();
        history.push(url);
    }

    return (
        <section className="studentSidebar sidebar" id="studentSidebar">
            <div className="sidebar__item1" id="studentSidebar_profile" onClick={() => onSelect(ROUTES.PROFILE)}>
                <PersonOutlineOutlinedIcon/>
                <p>{t("student_sidebar_profile")}</p>
            </div>
            <div className="sidebar__item1" onClick={() => onSelect(ROUTES.FEED)}>
                <HomeOutlinedIcon/>
                <p>{t("student_sidebar_feed")}</p>
            </div>
            <div className="sidebar__item1" id="myVivai">
                <StarBorderOutlinedIcon/>
                <p>{t("student_sidebar_myPaths")}</p>
            </div>
            {rms.map(rm => (
                <div key={rm?.id} className="sidebar__item2" id="followButton" onClick={() => onRmClick(rm)}>
                    {rm?.name}
                </div>
            ))}
        </section>
    );
};